import { useSelector } from "react-redux";
import { getUnitMultiplier } from "../utils";
import { chartViewModeSelector } from "../../../../redux/modules/common/building/manufacturing/selectors";

export const useUnitMultiplier = () => {
  const chartViewMode = useSelector(chartViewModeSelector);
  return getUnitMultiplier(chartViewMode);
};
